module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "mapHelp"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "Centrer la carte"
    },
    on: {
      "click": _vm.centeringMap
    }
  }), _vm._v(" "), (_vm.user !== null && _vm.token !== null) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Réinitialiser le parcours "
    },
    on: {
      "click": function($event) {
        _vm.showRest = true;
      }
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showRest) ? _c('div', {
    attrs: {
      "id": "popinResetCircuits"
    }
  }, [_c('div', [_c('p', {
    staticClass: "mapHelp alignCenter"
  }, [_vm._v("\n        Attention ! Cette action supprimera l'ensemble des réponses du parcours"), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "id": "validation",
      "value": "Confirmer"
    },
    on: {
      "click": _vm.resetCircuitResult
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "id": "annullation",
      "value": "Annuler"
    },
    on: {
      "click": function($event) {
        _vm.showRest = false
      }
    }
  })])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "declickMap"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "map"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45b8796e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/DeclickMap.vue
// module id = 592
// module chunks = 2